/**
 * @generated SignedSource<<6f49f537e3cf0bf740ddfecdfbb9e47a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField$data = {
  readonly id: string;
  readonly notifyOwnChangesEnabled: boolean | null | undefined;
  readonly " $fragmentType": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField";
};
export type notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField$key = {
  readonly " $data"?: notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField$data;
  readonly " $fragmentSpreads": FragmentRefs<"notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ScalarField",
      "name": "notifyOwnChangesEnabled"
    }
  ],
  "type": "JiraNotificationOptions"
};

(node as any).hash = "0770bc0487be60d78cf1a64f40e601ec";

export default node;
